export const FETCH_CENTERS = 'FETCH_CENTERS';
export const CREATE_CENTERS = 'CREATE_CENTERS';
export const UPDATE_CENTERS = 'UPDATE_CENTERS';
export const DELETE_CENTERS = 'DELETE_CENTERS';
export const CREATE_CENTER_SERVICE = 'CREATE_CENTER_SERVICE';
export const UPDATE_CENTER_SERVICE = 'UPDATE_CENTER_SERVICE';
export const DELETE_CENTER_SERVICE = 'DELETE_CENTER_SERVICE';
export const CREATE_CENTER_SERVICE_PRICE = 'CREATE_CENTER_SERVICE_PRICE';
export const UPDATE_CENTER_SERVICE_PRICE = 'UPDATE_CENTER_SERVICE_PRICE';
export const DELETE_CENTER_SERVICE_PRICE = 'DELETE_CENTER_SERVICE_PRICE';
